export function sortOnProperty<T>(array: T[], property: keyof T, direction: 'ascending' | 'descending'): T[] {
  // Maak een kopie van de array met [...array] om de originele niet te wijzigen
  return [...array].sort((a, b) => {
    if (a[property] > b[property]) {
      return direction === 'ascending' ? 1 : -1;
    } else if (a[property] < b[property]) {
      return direction === 'ascending' ? -1 : 1;
    } else {
      return 0;
    }
  });
}
